export const ROW_GUTTER = 16;
/** Alinhado a `@side-nav-width` em `_template.less` (menu DIMO) */
export const SIDE_NAV_WIDTH = 240;
export const SIDE_NAV_COLLAPSED_WIDTH = 80;
export const SIDE_NAV_LIGHT = "SIDE_NAV_LIGHT";
export const SIDE_NAV_DARK = "SIDE_NAV_DARK";
export const NAV_TYPE_SIDE = "SIDE";
export const NAV_TYPE_TOP = "TOP";
export const DIR_LTR = "ltr";
export const DIR_RTL = "rtl";

/** Header / layout (menu DIMO — mesmo padrão gestao-financeira-front) */
export const TEMPLATE = {
	HEADER_HEIGHT: 64,
	HEADER_BG_DEFAULT_COLOR_LIGHT: "#ffffff",
	HEADER_BG_DEFAULT_COLOR_DARK: "#12151c",
	TOP_NAV_HEIGHT: 55,
	CONTENT_MAX_WIDTH: 1400,
	CONTENT_HEIGHT_OFFSET: 64 + 60,
	SIDE_NAV_WIDTH,
	SIDE_NAV_COLLAPSED_WIDTH,
	NAV_TYPE_SIDE,
	NAV_TYPE_TOP,
	DIR_LTR,
	DIR_RTL,
};
